import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const INTERVAL = 15000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: number | undefined;
    const cycle = () => {
      setIndex(Math.floor(Math.random() * recentBuyers.length));
      setMinutesAgo(Math.floor(Math.random() * 9) + 1);
      setShow(true);
      hideTimer = window.setTimeout(() => setShow(false), VISIBLE_FOR);
    };
    const first = window.setTimeout(cycle, FIRST_DELAY);
    const loop = window.setInterval(cycle, INTERVAL);
    return () => {
      window.clearTimeout(first);
      window.clearInterval(loop);
      if (hideTimer) window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  const buyer = recentBuyers[index];
  return <div className="pointer-events-none fixed bottom-24 left-3 right-3 z-50 sm:right-auto sm:w-80" aria-live="polite" data-id="element-240" data-mp="116miqyxel085">
      <AnimatePresence data-id="element-241" data-mp="1fxmzdr8b00fd">
        {show && !dismissed && <motion.div key={`${buyer.name}-${index}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex items-center gap-3 rounded-2xl border border-line bg-white p-3 pr-9 shadow-xl" data-id="element-242" data-mp="1ay0pnrrop2bb">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-navy font-display text-xl font-bold text-white" data-id="element-243" data-mp="28kg2uhd2vdt2">
              {buyer.name.charAt(0)}
            </span>
            <div className="min-w-0" data-id="element-244" data-mp="2aotk8d64zvi5">
              <p className="text-sm leading-snug text-ink" data-id="element-245" data-mp="2anrvx7041cih">
                <strong data-id="element-246" data-mp="2fne8de846oq8">{buyer.name}</strong> from <strong data-id="element-247" data-mp="2fmmqt7bcqriy">{buyer.country}</strong>
              </p>
              <p className="text-sm leading-snug text-muted" data-id="element-248" data-mp="2kn0mrqzoib0m">just purchased the Blueprint™</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-semibold text-success" data-id="element-249" data-mp="2plu4jvm00o6l">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-250" data-mp="1ry3iwsw7sgre" />
                Verified · {minutesAgo} min ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-2 top-2 rounded-full p-1 text-muted hover:text-ink" data-id="element-251" data-mp="1wxodkr4cq2yb">
              <XIcon className="h-4 w-4" data-id="element-252" data-mp="197u6yramlami" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}